import styled, { css } from "styled-components";

export const CustomCssWrapper = styled.div<{ customCss: string }>((props) => {
  return css`
    min-width: 100%;
    height: 100%;
    ${props.customCss};
  `;
});
